import React, { Component } from 'react';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { styles } from '../../containers/dockPadStyle';
import { CircularProgress } from "@material-ui/core/";
import Dialog from '@material-ui/core/Dialog'
import { connect } from 'react-redux'


class CircularProgressDialog extends Component {
    render() {
      const { classes, isLoading  } = this.props

        return (
          <Dialog
            open={!!isLoading}>
              <CircularProgress size={100} variant='indeterminate' disableShrink={true} className={classes.circleProgressDialog} />
          </Dialog>
        )

    }
}

export default compose(
  withStyles(styles, { withTheme: true }),
  connect(state => {
    return {
      isLoading: state.homeView.circularProgressLoadingOpen,
    }
  })
)(CircularProgressDialog)



// WEBPACK FOOTER //
// ./src/components/Dialogs/CircularProgressDialog.tsx